import { render } from "./FilterParent.vue?vue&type=template&id=4eec5c54"
import script from "./FilterParent.vue?vue&type=script&lang=js"
export * from "./FilterParent.vue?vue&type=script&lang=js"
script.render = render

export default script